const createWidgetFactory = require('components/framework/widget/create_widget_factory');
const View = require('./view');

module.exports = createWidgetFactory({
    name: 'ip_touchpoint',
    viewClass: View,
    methods: {},
});
